/** localStorage for EVO Magenta flavour-profile question (/npd-awareness). */
export const NPD_AWARENESS_STORAGE_KEY = 'ploomsurvey:npdAwareness';

export type NpdAwarenessAnswer = 'muscat_grape' | 'berry' | 'lychee';

export const NPD_CORRECT_ANSWER: NpdAwarenessAnswer = 'muscat_grape';

export type NpdAwarenessAnswers = {
  flavour: NpdAwarenessAnswer;
};

export function readNpdAwarenessAnswers(): NpdAwarenessAnswers | null {
  try {
    const raw = localStorage.getItem(NPD_AWARENESS_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const r = (o as { flavour?: unknown }).flavour;
    if (r === 'muscat_grape' || r === 'berry' || r === 'lychee') {
      return { flavour: r };
    }
    return null;
  } catch {
    return null;
  }
}

export function writeNpdAwarenessAnswers(data: NpdAwarenessAnswers): void {
  try {
    localStorage.setItem(NPD_AWARENESS_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearNpdAwarenessAnswers(): void {
  try {
    localStorage.removeItem(NPD_AWARENESS_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isNpdAwarenessComplete(): boolean {
  return readNpdAwarenessAnswers() != null;
}

export function isNpdAwarenessCorrect(): boolean {
  return readNpdAwarenessAnswers()?.flavour === NPD_CORRECT_ANSWER;
}
